export default __webpack_public_path__ + "static/media/clapperboard.c534a56b.svg";